import { PushActionButton, PushActionButtonType } from 'modules/graphql/types';
import { ActionButtonPreview, PushPreviewType } from '../common';
import { actionButtons, actionButtonText, actionButtonWrapper } from './preview/styles';

type PreviewActionButtonsProps = {
  buttons: PushActionButton[];
  selectedPreviewType: PushPreviewType;
};

export const PreviewActionButtons = ({
  buttons,
  selectedPreviewType,
}: PreviewActionButtonsProps) => {
  const arraySize = buttons.length;
  const isTypeNotification = selectedPreviewType === PushPreviewType.notification;
  const typeBasedFirst = isTypeNotification
    ? ActionButtonPreview.first
    : ActionButtonPreview.expandedFirst;
  const typeBasedMiddle = isTypeNotification
    ? ActionButtonPreview.middle
    : ActionButtonPreview.expandedMiddle;
  const typeBasedLast = isTypeNotification
    ? ActionButtonPreview.last
    : ActionButtonPreview.expandedLast;
  const typeBasedSingle = isTypeNotification
    ? ActionButtonPreview.single
    : ActionButtonPreview.expandedSingle;

  const handlePreviewButtons = () => {
    return buttons.map((button, i) => {
      const textType =
        button.buttonType === PushActionButtonType.destructive
          ? PushActionButtonType.destructive
          : PushActionButtonType.default;
      let styleType;

      if (arraySize > 1 && i === 0) {
        styleType = typeBasedFirst;
      } else if (arraySize === 3 && i === 1) {
        styleType = typeBasedMiddle;
      } else if (arraySize - 1 === i && i !== 0) {
        styleType = typeBasedLast;
      } else {
        styleType = typeBasedSingle;
      }

      return (
        <div
          data-test={`push-preview-ios-action-button-${i}`}
          key={i}
          style={actionButtons[styleType]}
        >
          <span style={actionButtonText[textType]}>{button.title}</span>
        </div>
      );
    });
  };

  return <div style={actionButtonWrapper}>{handlePreviewButtons()}</div>;
};
